export const ApiRequirements = {
    get: params => ({
        url: '/requirements',
        method: 'GET',
        params
    }),
    create: name => ({
        url: '/requirements',
        method: 'POST',
        data: {
            name
        }
    }),
    update: (id, name) => ({
        url: `/requirements/${id}`,
        method: 'PUT',
        data: {
            name
        }
    }),
    delete: (id) => ({
        url: `/requirements/${id}`,
        method: 'DELETE',
    })
};